export const colours = [
  "beige",
  "black",
  "blue",
  "brown",
  "burgundy",
  "cream",
  "gold",
  "green",
  "grey",
  "maroon",
  "orange",
  "pearl",
  "purple",
  "red",
  "silver",
  "teal",
  "turquoise",
  "white",
  "yellow",
  "other"
];
